import React, { Component, useState } from 'react'
import '../BranchMangement/BranchListContainer.css'
import { Container, Row, Col } from 'reactstrap'
import ObjectPermissionsList from "./ObjectPermissionsList"
import NewObjectPermissionModal from "./NewObjectPermissionModal"
import RestrictedSection from "../../Components/RestrictedSection"
import AdvancedFilters from '../../Filters/AdvancedFilters'
import AdvancedFiltersTrigger from '../../Filters/AdvancedFiltersTrigger'
import AppliedAdvancedFilters from '../../Filters/AppliedAdvancedFilters'
import { useAdvancedFilters } from '../../Filters/filterUrl'
import { countVisibleFilters } from '../../Filters/presetFilters'

// Advanced filters live in the URL (useAdvancedFilters); this control just hosts
// the popover open/close state so the class container can render it.
function ObjectPermissionsAdvancedFiltersControl() {
    const [isOpen, setIsOpen] = useState(false)
    const [advancedFilters, setAdvancedFilters] = useAdvancedFilters()
    return (
        <>
            <AdvancedFiltersTrigger count={countVisibleFilters(undefined, advancedFilters)} onClick={() => setIsOpen(!isOpen)} />
            {isOpen && (
                <AdvancedFilters
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    entity="group_object_permission"
                    context={null}
                    activeFilters={advancedFilters}
                    onApply={(newFilters) => setAdvancedFilters(newFilters)}
                />
            )}
        </>
    )
}

class ObjectPermissionsListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorMessage: null,
            searchTerm: "",
        }
    }
    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (value === "null") {
            value = null
        }
        if (e.target.dataset.type) {
            if (value === "false") {
                value = false
            } else {
                value = true
            }
        }

        this.setState({ [name]: value })
    };

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    render() {
        return (
            <RestrictedSection requiredPermission="view_groupobjectpermission">
                <Container fluid className="bos-listing-container">
                    <Row>
                        <Col xs={{ offset: 4, size: 8 }} className="text-right mt-2">
                            <a className="driver-list-button" onClick={() => this.toggleModal("newObjectPermissionModal")}>
                                Create Object Permission | <i className="fa fa-user-plus" aria-hidden="true"></i>
                            </a>
                            {this.state.openModal === "newObjectPermissionModal" && <NewObjectPermissionModal handleClose={() => this.toggleModal("newObjectPermissionModal")} open={this.state.openModal === "newObjectPermissionModal"} />}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <ObjectPermissionsAdvancedFiltersControl />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className="mt-2 search-filter-container">
                            <AppliedAdvancedFilters entity="group_object_permission" context={null} />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col>
                            <ObjectPermissionsList searchTerm={this.state.searchTerm ? this.state.searchTerm : ""} />
                        </Col>
                    </Row>
                </Container>
            </RestrictedSection>
        )
    }
}

export default ObjectPermissionsListContainer